import { withNamespaces } from 'react-i18next';
import { Card } from 'reactstrap';
import { Link } from 'react-router-dom';

import useMailboxActions from '../../hooks/useMailboxActions';
import useMailboxIntentsQuery from '../../hooks/useMailboxIntentsQuery';
import useMailboxUnreadCount from '../../hooks/useMailboxUnreadCount';
import {
    getMailboxComposePath,
    getMailboxFolderItems,
    getMailboxFolderPath,
    getMailboxIntentItem,
    getMailboxIntentItems,
    getMailboxSidebarLabelCodes,
} from '../../helpers';

const EmailSidebar = ({
    t,
    activeView,
    activeFolder,
    enabled = true,
}) => {
    const inboxUnreadCount = useMailboxUnreadCount({
        enabled,
    });
    const { syncMailbox } = useMailboxActions({ t });
    const folderItems = getMailboxFolderItems();
    const labelCodes = getMailboxSidebarLabelCodes();
    const intentItems = getMailboxIntentItems();
    const intents = useMailboxIntentsQuery({
        enabled: enabled && labelCodes.length > 0,
    });
    const labelItems = labelCodes.map((code) => {
        const intent = intents.find((item) => item.code === code)
            || getMailboxIntentItem(code)
            || intentItems.find((item) => item.code === code);

        return {
            ...intent,
            count: intent?.count || 0,
        };
    }).filter(Boolean);

    return (
        <Card className="email-leftbar mailbox-sidebar">
            <Link
                to={{
                    pathname: getMailboxComposePath(),
                    state: {
                        mailboxFolderPath: activeView === 'folder'
                            ? getMailboxFolderPath(activeFolder)
                            : undefined,
                    },
                }}
                className={`btn btn-primary w-100 waves-effect waves-light${activeView === 'compose' ? ' active' : ''}`}
            >
                {t('Compose')}
            </Link>

            <div className="mail-list mt-4">
                {folderItems.map((item) => {
                    const isActive = activeView === 'folder' && activeFolder === item.key;

                    return (
                        <Link
                            key={item.key}
                            to={item.path}
                            className={isActive ? 'active' : ''}
                            onClick={() => {
                                if (item.key === 'inbox') {
                                    syncMailbox({ silent: true });
                                }
                            }}
                        >
                            <i className={`${item.icon} me-2`} />
                            <span className="mailbox-sidebar__folder-title">
                                {t(item.titleKey)}
                            </span>
                            {item.key === 'inbox' && inboxUnreadCount > 0 ? (
                                <span className="mailbox-sidebar__unread">
                                    {inboxUnreadCount}
                                </span>
                            ) : null}
                        </Link>
                    );
                })}
            </div>

            {labelItems.length ? (
                <>
                    <h6 className="mailbox-sidebar__labels-heading mt-4 mb-2">
                        {t('Labels')}
                    </h6>
                    <div className="mail-list mailbox-sidebar__labels">
                        {labelItems.map((item) => (
                            <span
                                key={item.code}
                                className="mailbox-sidebar__label"
                            >
                                <span className={`mailbox-sidebar__dot ${item.labelDotClass || ''}`} />
                                <span className="mailbox-sidebar__label-title">
                                    {t(item.titleKey)}
                                </span>
                                <span className="mailbox-sidebar__label-count">
                                    {item.count}
                                </span>
                            </span>
                        ))}
                    </div>
                </>
            ) : null}
        </Card>
    );
};

export default withNamespaces()(EmailSidebar);
